import { mutationFor } from "@visioni/a3s-client-api/app";
import {
  inviteUserEndpoint,
  revokeUserAccessEndpoint,
  setUserPermissionsEndpoint,
} from "../client-messages/role-assignments";

export const inviteUserMutation = mutationFor(inviteUserEndpoint);

export const revokeUserAccessMutation = mutationFor(revokeUserAccessEndpoint);

export const setUserPermissionsMutation = mutationFor(setUserPermissionsEndpoint);
